// Shared constants and utilities for QuickInput components

// Style for compulsory/required fields - subtle pastel highlight
export const REQ = "rounded-sm bg-amber-50 border-amber-200 focus:bg-white";
// Style for invalid/empty required fields - red highlight
export const INVALID = "rounded-sm border-red-400 bg-red-50 focus:border-red-500";

// Helper to check if value is empty or zero
export const isEmptyOrZero = (value) => {
  if (value === undefined || value === null || value === "") return true;
  const num = parseFloat(String(value).replace(/,/g, ''));
  return isNaN(num) || num === 0;
};

// Check if a field value is explicitly zero (not empty)
export const isExplicitZero = (value) => {
  if (value === undefined || value === null || value === "") return false;
  const num = parseFloat(String(value).replace(/,/g, ''));
  return !isNaN(num) && num === 0;
};

// Society charge fields that need zero confirmation
export const SOCIETY_CHARGE_FIELDS = {
  rentPerSqftFlat: "Rent - Flat (₹/sft)",
  rentPerSqftOffice: "Rent - Office (₹/sft)",
  rentPerSqftShop: "Rent - Shop (₹/sft)",
  shiftingCharges: "Shifting Charges",
  corpusCharges: "Corpus Charges",
  bettermentCharges: "Betterment Charges (Flats)",
  bettermentChargesOffices: "Betterment Charges (Offices)",
  bettermentChargesShops: "Betterment Charges (Shops)"
};

// Format number as Indian currency
export const formatIndianNumber = (num) => {
  if (num === undefined || num === null || isNaN(num)) return "0";
  return num.toLocaleString('en-IN');
};

// Parse Indian formatted number
export const parseIndianNumber = (str) => {
  if (!str) return 0;
  return parseFloat(String(str).replace(/,/g, '')) || 0;
};

// Check if project is greenfield
export const isGreenfield = (formData) => {
  return formData.projectClassification === "greenfield" || formData.projectMode === "greenfield";
};

// Check if project is MHADA
export const isMHADA = (formData) => {
  return formData.projectClassification === "mhada";
};

// Check if project is commercial
export const isCommercial = (formData) => {
  return formData.projectType === "commercial";
};

// Check if project is residential
export const isResidential = (formData) => {
  return formData.projectType === "residential";
};

// Check if project is mixed use
export const isMixedUse = (formData) => {
  return formData.projectType === "mixed";
};

// Check if project shows commercial fields (not purely residential)
export const showsCommercialFields = (formData) => {
  return formData.projectType === "commercial" || formData.projectType === "mixed";
};
